// extracted by mini-css-extract-plugin
module.exports = {"section":"Certification_section__1yS0-","youtube":"Certification_youtube__3tT7u","agree":"Certification_agree__1B6eb"};